import { render, staticRenderFns } from "./ScenceTypeFormModal.vue?vue&type=template&id=48c4d591&scoped=true"
import script from "./ScenceTypeFormModal.vue?vue&type=script&lang=js"
export * from "./ScenceTypeFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c4d591",
  null
  
)

export default component.exports